import React from 'react'
import Layout from '../../core/layout/layout'
import styled from 'styled-components'
import SectionTC from '../../components/section-tc/section-tc'
import { listOfferItem } from '../landing/data'
import CustomSlider from '../../components/custom-slider/custom-slider'
import PaymentMethods from '../landing/components/payment-methods/payment-methods'
import Slider from "react-slick";
import OfferItem from '../landing/components/offer-item/offer-item'
import SectionFull from '../../components/section-full/section-full'
import { device } from '../../config/theme/breakpoints'
import TitleSection from '../../components/title-section/title-section'
import MainAccount from './components/main-account'

const customSectionPayment = `
    background: #F2F2F2;

    > div:nth-child(1){
        margin: auto;
    }
`
const customSectionAccount = `
    border-top: 1px solid #B1B1B1;

    > div:nth-child(1){
        margin: auto;
        width: 100%;
    }
`

const ContainerAccount = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: content;
    align-items: flex-start;
    width: 100%;
`

const ContainerOptions = styled.div`
    width: 100%;
    border-right: 2px solid #F2F2F2;
    
    @media ${device.tablet}{
        width: 30%;
    }
`
const ContainerBody = styled.div`
    width: 100%;
    padding: 40px;
    display: flex;
    flex-direction: column;
    border-left: 2px solid #F2F2F2;
    
    @media ${device.tablet}{
        width: 70%;
    }
`
const OptionAccount = styled.div<{ option: boolean }>`
    width: 100%;
    padding: 10px;
    cursor: pointer;
    padding-left: 20px;
    border-radius: 6px;
    border-bottom: 2px solid #F2F2F2;
    background: ${p => p.option ? '#F2F2F2' : 'white'};
    ${p => p.option ? 
        `border-left: 4px solid ${p.theme.palette.primary.main};
        border-top: 2px solid #F2F2F2;
        border-right: 2px solid #F2F2F2;` 
        : ''};
`

const MyAccount: React.FunctionComponent = () => {
    const [option, setOption] = React.useState(1);
  const sliderOfferRef = React.useRef<Slider>(null);
  const handleClick = (option: number) => setOption(option);

  return (
    <Layout>
        <SectionFull className={customSectionAccount}>
            <SectionTC>
                <ContainerAccount>
                    <ContainerOptions>
                        <TitleSection title='Mi Cuenta' preTitle=''/>
                        <OptionAccount option={option===1} onClick={() => handleClick(1)}><h4>Mi Cuenta</h4></OptionAccount>
                        <OptionAccount option={option===2} onClick={() => handleClick(2)}><h4>Ingresa a mis datos</h4></OptionAccount>
                        <OptionAccount option={option===3} onClick={() => handleClick(3)}><h4>Documentos de viaje</h4></OptionAccount>
                        <OptionAccount option={option===4} onClick={() => handleClick(4)}><h4>Ingresa a documentos de viaje</h4></OptionAccount>
                        <OptionAccount option={option===5} onClick={() => handleClick(5)}><h4>Métodos de pago</h4></OptionAccount>
                        <OptionAccount option={option===6} onClick={() => handleClick(6)}><h4>Configuración de notificaciones</h4></OptionAccount>
                    </ContainerOptions>
                    <ContainerBody>
                        {option === 1 && <MainAccount />}
                        {option === 2 && <MainAccount />}
                        {option === 3 && <>3</>}
                        {option === 4 && <>4</>}
                        {option === 5 && <>5</>}
                        {option === 6 && <>6</>}
                    </ContainerBody>
                </ContainerAccount>
            </SectionTC>
        </SectionFull>
        <SectionFull className={customSectionPayment}>
            <SectionTC>
                <PaymentMethods />
            </SectionTC>
        </SectionFull>
        <CustomSlider
          sliderRef={sliderOfferRef}
          preTitle='Principales destinos'
          title='Y promociones'
          size={listOfferItem.length}
          withIconRight
        >
          {listOfferItem.map(offer => (
            <div key={offer.id}>
              <OfferItem
                  tour={offer.tour}
                  price={offer.price}
                  title={offer.title}
                  subTitle={offer.subTitle}
                  image={offer.image}
                />
            </div>
          ))}
        </CustomSlider>
    </Layout>
  )
}

export default MyAccount